import { OutlineTable, PageContent, PageToolbar, TableHeader, Title } from '@recargas-dominicanas/core/components';
import { PageContainer } from '@recargas-dominicanas/core/components';
import { ProductItem } from './product-item/product-item.component';
import { useProductStore } from '../../stores/productStore';
import { style } from './products.module.css';

export function Products() {

  const { products } = useProductStore();

  return (
    <PageContainer className={style.container}>
      <PageToolbar className={style.toolbar}>
        <Title style={style.title} title='Productos'/>
      </PageToolbar>
      <PageContent className={style.content}>
        <OutlineTable style={style.table}>
          <TableHeader style={style.tableHeader}>
            <span>Logo</span>
            <span>Nombre</span>
            <span>Tipo</span>
            <span>Beneficio</span>
          </TableHeader>
          <tbody>
            {
              products?.map(product => 
                <ProductItem
                  key={product.id} 
                  customerProduct={product}/>
              )
            }
          </tbody>
        </OutlineTable>
      </PageContent>
    </PageContainer>
  );
}
